export default "__VITE_ASSET__uVcdgR3o__"